import { useParams } from "react-router-dom";

import { useGetRespondentQuestionnaire, type QuestionnaireResponse } from "@wellcheck/api-client";

import { DEFAULT_LOCALE, isSupportedLocale } from "@/i18n/config";

/**
 * useQuestionnaire — 回答者向け設問取得 (GET /api/respondent-questionnaire, ADR-0024/0033)。
 *
 * orval 生成の useGetRespondentQuestionnaire を QuestionnaireResponse そのまま返す形に薄くラップする。
 * URL の :lang セグメント (言語決定の一次ソース、LanguageRoute 参照) を lang クエリとして渡す。
 * orval の query key は params を含むため、lang 切替は useEffect なしで自動 refetch される。
 * 401 (セッション無効) はセッション自体が invalid のはずなので、RespondPage 側の
 * useRespondSession が先に弾く想定だが、念のためリトライはしない。
 */
export function useQuestionnaire() {
  const { lang } = useParams<{ lang: string }>();
  const current = isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;

  return useGetRespondentQuestionnaire(
    { lang: current },
    {
      query: {
        retry: false,
        select: (response): QuestionnaireResponse | undefined =>
          response.status === 200 ? response.data : undefined,
      },
    },
  );
}
